import SikaLogo from '../assets/Sika.png'
import CiplakLogo from '../assets/Ciplak.png'
import PortokollLogo from '../assets/PortoKoll.png'
import LigamaxLogo from '../assets/Ligamax.png'
import IgolFlex from '../assets/IgolFlex.png'

interface Brand {
    name: string,
    image?: any,
    altImage: string
}

export const brands: Brand[] = [
    {
        name: 'Sika',
        image: SikaLogo,
        altImage: 'Marca Sika'
    },
    {
        name: 'CIPLAK',
        image: CiplakLogo,
        altImage: 'Marca CIPLAK'
    },
    {
        name: 'Portokoll',
        image: PortokollLogo,
        altImage: 'Marca Portokoll'
    },
    {
        name: 'Ligamax',
        image: LigamaxLogo,
        altImage: 'Marca Ligamax'
    },
    {
        name: 'Igolflex',
        image: IgolFlex,
        altImage: 'Marca Igolflex'
    },
    {
        name: 'Outros',
        altImage: 'Outras opções'
    }
]